import { render, staticRenderFns } from "./ChatResourceCard.vue?vue&type=template&id=0bc5964a&scoped=true"
import script from "./ChatResourceCard.vue?vue&type=script&lang=js"
export * from "./ChatResourceCard.vue?vue&type=script&lang=js"
import style0 from "./ChatResourceCard.vue?vue&type=style&index=0&id=0bc5964a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5964a",
  null
  
)

export default component.exports